/* Cart recommendations — add to cart WITHOUT a form element.

   WHY THERE IS NO <form> HERE. This is the whole point of the file.
   PreProduct binds its pre-order takeover to the FIRST
   form[action*="/cart/add"] in the document. The cart drawer is present
   in the DOM on every page of the store, so an add-to-cart form inside
   the drawer becomes that first form as soon as the cart has items. On
   10 September that shadowed the real buy button on 15 of 45 products
   and they could not be purchased. The block was pulled the same day.

   A <button type="button"> is not a form and cannot be bound. There is
   nothing to be careful about here, because there is nothing to find.
   Do NOT "restore" {% form 'product' %} or <product-form>, in either
   context, however much shorter the code looks.

   The trade-off is that Dawn's ProductForm no longer does the POST and
   the section re-render for us, so this file does both by hand.

   FIVE SECTION CAP. The Section Rendering API silently returns invalid
   JSON above five sections per request, which reads exactly like a
   caching bug. Both branches below request four or fewer. Count before
   you add one.
*/

(function () {
  if (window.ccCartRecosReady) return;
  window.ccCartRecosReady = true;

  const root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

  /* The drawer's sections are theme-level and can be named directly.
     The cart page's are template-scoped, so their real ids have to be
     read off the DOM: "main-cart-items" is the ELEMENT id, but the
     SECTION id is something like template--22499105734883__cart-items.
     Passing the element id renders the wrong thing, silently. */
  function sectionsFor(ctx) {
    if (ctx === 'drawer') return ['cart-drawer', 'cart-icon-bubble'];
    const ids = ['cart-icon-bubble'];
    ['main-cart-items', 'cart-recommendations', 'main-cart-footer'].forEach(function (elId) {
      const el = document.getElementById(elId);
      if (el && el.dataset.id) ids.push(el.dataset.id);
    });
    return ids;
  }

  function swap(html, sourceSelector, targetSelector) {
    if (!html) return;
    const target = document.querySelector(targetSelector);
    if (!target) return;
    const parsed = new DOMParser().parseFromString(html, 'text/html');
    const source = parsed.querySelector(sourceSelector);
    if (!source) return;
    target.innerHTML = source.innerHTML;
  }

  function applyDrawer(sections) {
    /* .drawer__inner carries the line items, the shipping bar, the recos
       block and the reassurance copy. Replacing the whole thing keeps
       every one of them in step with the new cart. */
    swap(sections['cart-drawer'], '.drawer__inner', '#CartDrawer .drawer__inner');
    swap(sections['cart-icon-bubble'], '.shopify-section', '#cart-icon-bubble');

    const drawer = document.querySelector('cart-drawer');
    if (drawer) drawer.classList.remove('is-empty');
  }

  function applyPage(sections) {
    Object.keys(sections).forEach(function (key) {
      const html = sections[key];
      if (key === 'cart-icon-bubble') {
        swap(html, '.shopify-section', '#cart-icon-bubble');
        return;
      }
      const parsed = new DOMParser().parseFromString(html, 'text/html');
      const source = parsed.querySelector('.js-contents');
      if (!source) return;
      /* Match the rendered section back to its host element by data-id. */
      const host = document.querySelector('[data-id="' + key + '"] .js-contents');
      if (host) host.innerHTML = source.innerHTML;
    });
  }

  function setError(button, message) {
    const wrap = button.closest('.cc-reco');
    if (!wrap) return;
    let node = wrap.querySelector('.cc-reco__error');
    if (!node) {
      node = document.createElement('p');
      node.className = 'cc-reco__error';
      node.setAttribute('role', 'alert');
      wrap.appendChild(node);
    }
    node.textContent = message;
  }

  document.addEventListener('click', async function (event) {
    const button = event.target.closest('[data-cc-reco-add]');
    if (!button) return;

    event.preventDefault();
    if (button.getAttribute('aria-busy') === 'true') return;

    const variantId = Number(button.dataset.variantId);
    if (!variantId) return;

    const ctx = button.dataset.ccCtx === 'drawer' ? 'drawer' : 'page';
    button.setAttribute('aria-busy', 'true');
    button.classList.add('loading');
    setError(button, '');

    try {
      const response = await fetch(root + 'cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({
          items: [{ id: variantId, quantity: 1 }],
          sections: sectionsFor(ctx).join(','),
          sections_url: window.location.pathname
        })
      });

      const data = await response.json();

      /* cart/add.js returns a `status` key only on failure. */
      if (data.status) {
        setError(button, data.description || data.message || 'Could not add that. Try again.');
        return;
      }

      if (data.sections) {
        if (ctx === 'drawer') applyDrawer(data.sections);
        else applyPage(data.sections);
      }

      document.dispatchEvent(
        new CustomEvent('cc:reco:added', { detail: { variantId: variantId, context: ctx } })
      );
    } catch (error) {
      setError(button, 'Could not add that. Try again.');
    } finally {
      button.setAttribute('aria-busy', 'false');
      button.classList.remove('loading');
    }
  });
})();
